/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */

import { Analysis } from './analysis';
import { Dangers } from './dangers';
import { Table } from './efficiency-verification';
import { Header } from './header';
import { ItemContext, ReportContext } from './hooks/use-context';
import { InitialInfos } from './initial-infos';
import { Labels } from './labels';
import { OccurenceInfo } from './occurence-info';
import { Pictures } from './pictures';
import { Providences } from './providences';
import type { EventReportData } from './types';

export function GoiasaRiskSeries(props: { reportData: EventReportData }) {
  return (
    <ReportContext value={props.reportData}>
      <div style={{ breakAfter: 'page' }}>
        {props.reportData.body.items.map((item) => (
          <ItemContext value={item}>
            <div
              style={{
                height: '90%',
                width: '100vw',
                flex: 1,
                backgroundColor: 'white',
                fontFamily: 'sans-serif',
              }}
            >
              <div
                style={{
                  margin: '1rem auto',
                  height: 'auto',
                  maxWidth: '64rem',
                  pageBreakAfter: 'always',
                }}
              >
                <Header
                  sectionName={
                    props.reportData.header.event_name ||
                    props.reportData.header.formulary_name ||
                    ''
                  }
                />
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <InitialInfos />
                  <Dangers />
                  <Pictures />
                  <OccurenceInfo />
                </div>
              </div>
              <div
                style={{
                  margin: '1rem auto',
                  height: 'auto',
                  maxWidth: '64rem',
                  pageBreakAfter: 'always',
                }}
              >
                <Header sectionName="2 - ANÁLISE" />
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Analysis />
                </div>
              </div>
              <div
                style={{
                  margin: '1rem auto',
                  height: 'auto',
                  maxWidth: '64rem',
                  pageBreakAfter: 'always',
                }}
              >
                <Header sectionName="3 - PROVIDÊNCIAS" />
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Providences />
                </div>
              </div>
              <div
                style={{
                  margin: '1rem auto',
                  height: 'auto',
                  maxWidth: '64rem',
                  pageBreakAfter: 'always',
                }}
              >
                <Header sectionName="4 - ANÁLISE DE EFICÁCIA" />
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Table />
                </div>
              </div>
              <div
                style={{
                  margin: '1rem auto',
                  height: 'auto',
                  maxWidth: '64rem',
                  pageBreakAfter: 'always',
                }}
              >
                <Header sectionName="Série de Riscos" />
                <div
                  style={{
                    height: '100%',
                    width: '100%',
                    backgroundColor: '#fff',
                  }}
                >
                  <Labels />
                </div>
              </div>
            </div>
          </ItemContext>
        ))}
      </div>
    </ReportContext>
  );
}
